import { ProfileIcon } from "../../../assets"
import styles from "./style.module.css"

export const ProfileButton = () => {

    return(

            <ProfileIcon className={styles.icon}/>
    
    )

}